<shell-layout *ngIf="config" [error_identity]="true">
  <img class="m-auto" [src]="config.imageUrl.url" [alt]="config.imageUrl.url" />

  <ui-text class="error__title" color="blue-500" size="h4" weight="semibold" align="center">
    {{ config.errorTitle }}
  </ui-text>

  <ui-text class="error__description" color="blue-300" align="center">
    <span [innerHTML]="config.errorDescription"></span>
  </ui-text>

  <div class="error__action flex justify-center">
    <ui-button
      (clicked)="closeModal()"
      type="primary"
      [label]="config.buttonLabel"
      class="m-auto"
    ></ui-button>
  </div>
</shell-layout>
